export default {
  onboarding: {
    actions: {
      mainBlue: 'Iniziare'
    }
  },
  details: {
    stepTitle: 'Informazioni sulla richiesta di risarcimento',
    aboutProperty: 'Informazioni aggiuntive',
    title: 'Dettagli sui beni danneggiati:',
    errorMsgInputTxt: 'Campo obbligatorio',
    errorMsgGeneral: 'Si prega di controllare il modulo prima di continuare',
    errorImages: 'Si prega di aggiungere foto prima di continuare',
    warningMsg: 'Se queste informazioni sono incomplete o errate, si prega di contattare il rappresentante Allianz abituale.',
    address: {
      literal: 'Indirizzo',
      placeholder: 'Inserisci una posizione'
    },
    zipCode: {
      literal: 'Codice postale'
    },
    propertyType: {
      literal: 'Tipo di proprietà',
      options: {
        appartment: 'Flat',
        maison: 'Casa',
        local_commercial: 'Locali commerciali'
      }
    },
    residentType: {
      literal: 'Tipo di residente',
      options: {
        propietarie: 'Proprietario',
        locataire: 'Inquilino',
        propietarie_non_occupant: 'Proprietario Non Occupante'
      }
    },
    moreThanTwoYears: {
      literal: "Età dell'edificio",
      options: {
        more: 'Più di 2 anni',
        less: 'Meno di 2 anni'
      }
    },
    observations: {
      literal: 'Commenti'
    },
    map: {
      empty: {
        title: 'Nessun indirizzo',
        text: 'Inserisci un indirizzo valido'
      }
    },
    textArea: {
      placeHolder: 'Lunghezza del testo limitata a un massimo di 255 caratteri'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Continua con i danni ai mobili'
    }
  },
  compensationType: {
    title: 'Qual è la soluzione che preferite per i danni alla proprietà?',
    subtitle: 'A proposito dei danni alla tua propriet� ',
    propertyDamage: 'Danni materiali dichiarati',
    text: 'Per fare ciò, proponiamo tre possibili soluzioni:',
    recommended: 'La nostra raccomandazione!',
    amount: 'Importo rimborsato:',
    e2eCompensations: {
      ourRecommendation: 'La nostra raccomandazione',
      gagDetail: {
        title: 'Fare il lavoro da soli',
        text: 'Optando per questa soluzione, riceverete il seguente indennizzo immediato, che vi consentirà di eseguire i lavori autonomamente e di riportare la vostra proprietà alle condizioni originarie.',
        link: 'Scegliete questa soluzione'
      },
      billma: {
        title: 'Scegliere il proprio artigiano',
        text: 'Allegare il preventivo dell\'artigiano scelto per ricevere il compenso.',
        link: 'Scegliete questa soluzione'
      },
      renDetail: {
        title: 'Scegliere un artigiano autorizzato da Allianz',
        text: 'Comunicateci la vostra disponibilità in modo che un partner autorizzato da Allianz possa venire a riparare il vostro danno. Potrete beneficiare di riparazioni di qualità senza alcuna formalità amministrativa. Dovrete pagare solo la franchigia.',
        link: 'Scegliete questa soluzione'
      }
    }
  },
  compensationMobilier: {
    title: 'Per quanto riguarda i tuoi danni alla proprietà',
    subtitle: 'Importo del risarcimento',
    total: 'Total:',
    totalAmount: 'Compenso totale',
    actions: {
      primary: 'Sì, accetto il compenso proposto',
      secondary: 'Voglio parlare con un consulente'
    }
  }
}
